import { ValueOf } from '@/types/util';

export const EPaymentCategory = {
  10: '一括払い',
  21: 'ボーナス一括（支払月固定）',
  22: 'ボーナス二回（支払月固定）',
  23: 'ボーナス一括（支払月指定）',
  24: 'ボーナス二回（支払月指定）',
  31: 'ボーナス併用（開始月、回数指定）',
  34: 'ボーナス併用（開始月、回数、複数月、金額指定）',
  61: '分割払い',
  80: 'リボルビング',
} as const;

export type PaymentCategoryKey = `${keyof typeof EPaymentCategory}`;
export type PaymentCategoryValue = ValueOf<typeof EPaymentCategory>;

export const paymentCategoryKeys = Object.keys(EPaymentCategory) as PaymentCategoryKey[];

/** v-select用items */
export const paymentCategoryItems = paymentCategoryKeys
  .map((key) => ({
    title: EPaymentCategory[key],
    value: key,
  }));
